module.exports = __webpack_public_path__ + "static/img/kp.1c2fe3c1.png";